import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
})
export class FileUploadComponent {
  photoAlert: any;
  fileData: any[] = [];
  @Input('InputFile') fileHR: any;
  @Input() uploadText: string;
  innerCounter: number;
  @Input('OutputFile') attNewFile: any[] = [];
  validComboDrag: any;
  dragFiles: any;
  @Output() OutputFileChange = new EventEmitter<any[]>();

  constructor() {}

  personalInfoUpload() {
    var currentFiles = this.fileHR;
    this.fileHR = [];
    this.fileData = [];

    if (currentFiles !== null) {
      //process filename
      for (var i = 0; i < currentFiles.length; i++) {
        currentFiles[i].nameEdit = this.processFileName(currentFiles[i].name);
      }

      for (var i = 0; i < currentFiles.length; i++) {
        var preLoad = 0;
        this.innerCounter = 0;
        this.readFile(currentFiles[i], (e: any, fileName: string) => {
          setTimeout(() => {
            this.fileData.push({ data: e.target.result.toString().split(','), size: e.total, name: fileName });
            if (preLoad == currentFiles.length - 1) {
              this.fileData.forEach((val: any) => {
                currentFiles.forEach((val2: any) => {
                  if (val2.size === val.size && val.name === val2.name) {
                    this.attNewFile.push({ File: val.data[1], Filename: val2.nameEdit, Filedata: val2, Type: val.data[0].split('/')[0] });
                    this.OutputFileChange.emit(this.attNewFile);
                  }
                });
              });
            }
            preLoad++;
          });
        });
      }
    }
  }

  private processFileName(filename: string) {
    var editedFilename = '';
    for (var y = 0; y < filename.substr(0, filename.lastIndexOf('.') + 1).length; y++) {
      if (
        filename[y] != ' ' &&
        filename[y] != '&' &&
        filename[y] != '*' &&
        filename[y] != ':' &&
        filename[y] != ';' &&
        filename[y] != '|' &&
        filename[y] != '=' &&
        filename[y] != ',' &&
        filename[y] != '.' &&
        filename[y] != '/' &&
        filename[y] != '"' &&
        filename[y] != '[' &&
        filename[y] != ']'
      )
        editedFilename += filename[y];
    }
    editedFilename += filename.substr(filename.lastIndexOf('.'), filename.length);
    return editedFilename;
  }

  private readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = function (e) {
      return call(e, file.name);
    };
    reader.readAsDataURL(file);
  }

  attachDelete(index: any) {
    this.attNewFile.splice(index, 1);
    this.OutputFileChange.emit(this.attNewFile);
  }
}
